<div class='wrapperCopyLink' [class.o-opacity]='disable'>
  <svgAndText text='Copy Link' leftSvgName='squareTwo2&20' marginForLeftSvg='8' typeText='text7-blueDark' w='16'
              (click)='getLink()' [disable]='disable' [class.o-cur-default-important]='disable'></svgAndText>
  <meSvg *ngIf='showClock' svgName='clock_red&20' textMatTooltip='Link will be expired in 7 days'></meSvg>
</div>